import React, { useState, useEffect, useContext, useRef } from 'react';
import { TableFilterRow } from '@devexpress/dx-react-grid-bootstrap4';

import { DataContext } from '../../../stores/office-table-store';

import { InputDebouncer } from '../shared/FilterEventHelpers';

const FilterCell = ({ column, children, ...restProps }) => {
    const {
        store: { selectedFilters, isResettingFilters, filters },
        dispatch,
    } = useContext(DataContext);

    const columnName = column.name;

    // eslint-disable-next-line react-hooks/rules-of-hooks
    const [chosenValue, setChosenValue] = useState(selectedFilters[columnName]);
    const intervalRef = useRef(null);

    useEffect(() => {
        if (!(chosenValue === selectedFilters[columnName])) {
            return InputDebouncer(column, filters, chosenValue, intervalRef, children, dispatch);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [chosenValue]);

    useEffect(() => {
        return InputDebouncer(column, filters, chosenValue, intervalRef, children, dispatch); 
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [children[0].props.value]);

    useEffect(() => {
        if (isResettingFilters) {
            setChosenValue('');
            dispatch({ type: 'SELECTED_FILTERS_AND_FILTERS_RESET', columnName, payload: '' });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isResettingFilters]);

    var FilterOptions = children[0];
    var TextInput = React.cloneElement(children[1], {
        value: chosenValue,
        onChange: (event) => {
            setChosenValue(event);
            children[1].props.onChange();
        }
    });

    return (
        <TableFilterRow.Cell
            column={column}
            {...restProps}>
            {FilterOptions}
            {TextInput}
        </TableFilterRow.Cell>
    );
}

export default FilterCell;